var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWosmc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13104 -1776)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-13104 1776)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13099 1782.575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1285.6-210.025H1273.99c-1.075,0-1.482-.41-1.482-1.49q0-1.8,0-3.6c0-.933.425-1.363,1.369-1.364q11.7,0,23.407,0c.973,0,1.39.426,1.391,1.389q0,1.844,0,3.689a1.2,1.2,0,0,1-1.368,1.373Q1291.454-210.021,1285.6-210.025Zm7.814-4.087h-1.638c-1.241,0-1.224,0-1.238,1.239,0,.413.149.519.53.515,1.334-.015,2.669,0,4-.008,1.421-.011,1.2.2,1.232-1.278.007-.357-.126-.481-.479-.473C1295.024-214.1,1294.22-214.111,1293.416-214.111Z",
    transform: "translate(-1272.503 216.479)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.55-36.236h11.75c.918,0,1.339.412,1.341,1.322q.006,1.89,0,3.78a1.188,1.188,0,0,1-1.323,1.321h-23.5a1.186,1.186,0,0,1-1.341-1.3q-.014-1.935,0-3.871a1.122,1.122,0,0,1,1.276-1.247Q1279.652-36.237,1285.55-36.236Zm6.121,4.057h3.462c1.151,0,1.137,0,1.144-1.171,0-.412-.121-.551-.547-.548-2.43.018-4.859.009-7.289.009-1.217,0-1.2,0-1.217,1.216-.007.422.151.506.528.5C1289.059-32.19,1290.365-32.179,1291.671-32.179Z",
    transform: "translate(-1272.47 52.663)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.56-120.352h-11.251a4.345,4.345,0,0,1-.545-.018c-.927-.118-1.261-.5-1.264-1.445q0-1.822,0-3.644a1.25,1.25,0,0,1,1.4-1.409q11.684,0,23.367,0a1.252,1.252,0,0,1,1.4,1.41q0,1.868,0,3.735a1.168,1.168,0,0,1-1.13,1.326,4.381,4.381,0,0,1-.634.044Q1291.231-120.35,1285.56-120.352Zm2.946-2.429c2.263,0,4.526.007,6.789,0,1.1,0,.994.192,1-.982,0-.706,0-.708-.7-.708h-13.715c-1.192,0-1.178,0-1.187,1.212,0,.37.094.493.482.49C1283.615-122.79,1286.06-122.781,1288.506-122.782Z",
    transform: "translate(-1272.495 135.038)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWosmc);
export default __webpack_public_path__ + "static/media/wosmc.100a9122.svg";
export { ForwardRef as ReactComponent };